import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { SignaturesService } from '../../signatures/services/signatures.service'
import { setSignatureTypeOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getSignatureTypeOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const signaturesService = new SignaturesService(serviceId)
  try {
    const response = yield call([signaturesService, signaturesService.getSignatureTypes])
    const { entity } = response
    yield put(setSignatureTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSignatures() error: ${e}`))
  }
}
export function* getSignatureTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSignatureTypeOptions)
}
